import React from 'react';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const socialLinks = [
  { name: 'LinkedIn', href: '#', icon: 'in' },
  { name: 'Twitter', href: '#', icon: '𝕏' },
  { name: 'Instagram', href: '#', icon: '📷' },
  { name: 'Facebook', href: '#', icon: 'f' },
];

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'For Tenants', path: '/tenants' },
  { name: 'For Managers', path: '/managers' },
  { name: 'For Partners', path: '/partners' },
  { name: 'Get Started', path: '/get-started' },
];

const companyLinks = [
  // { name: 'Definite Assurance', href: '#' },
  // { name: 'Zyve Africa', href: '#' },
  // { name: 'Fluidyne Systems', href: '#' },
];

const legalLinks = [
  { name: 'Terms of Service', href: '#' },
  { name: 'Privacy Policy', href: '#' },
  { name: 'Cookie Policy', href: '#' },
];

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-b from-dark to-darker border-t border-white/5 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500 rounded-full mix-blend-screen filter blur-3xl opacity-[0.03]"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-cyan-500 rounded-full mix-blend-screen filter blur-3xl opacity-[0.03]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
                        <Link to="/" className="flex items-center gap-4 group mb-6">
                          <div className="w-14 h-14 rounded-full bg-white p-2 shadow-lg shadow-white/10 flex items-center justify-center">
                            <img src="/yawotelogo.png" alt="YAWOTE" className="w-full h-full object-contain" />
                          </div>
                          <span className="text-2xl font-bold text-gradient">YAWOTE</span>
                        </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-sm">
              Smart Rent. Smart Living. For Everyone. The all-in-one platform transforming rental living across Africa.
            </p>
            <p className="text-gray-500 text-xs">
              A product of{' '}
              <a href="https://victrie.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors">
                Victrie.com
              </a>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-6 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-1 group"
                  >
                    {link.name}
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity">→</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

                    {/* Our Partners */}
          <div>
            <h4 className="font-semibold text-white mb-6 text-sm uppercase tracking-wider">Our Partners</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-1 group"
                  >
                    {link.name}
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity">→</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-6 text-sm uppercase tracking-wider">Contact</h4>
            <div className="space-y-4">
              <a
                href="mailto:info@yawote.co.ke"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group"
              >
                <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center group-hover:bg-blue-500/20 transition-colors">
                  <Mail size={16} className="text-blue-400" />
                </div>
                <span className="text-sm">info@yawote.co.ke</span>
              </a>
              <a
                href="tel:+254713199322"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group"
              >
                <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center group-hover:bg-blue-500/20 transition-colors">
                  <Phone size={16} className="text-blue-400" />
                </div>
                <span className="text-sm">+254 713 199 322</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center">
                  <MapPin size={16} className="text-blue-400" />
                </div>
                <span className="text-sm">Nairobi, Kenya</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-3 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 hover:border-blue-500/30 transition-all"
                  aria-label={social.name}
                >
                  <span className="text-xs font-bold">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-gray-500 text-xs text-center md:text-left">
              &copy; {new Date().getFullYear()} yawote.co.ke — All Rights Reserved.
            </p>

            <div className="flex flex-wrap justify-center gap-6">
              {legalLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-500 hover:text-gray-300 transition-colors text-xs"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
